import { render, staticRenderFns } from "./tiktok_applicant.vue?vue&type=template&id=74a6b890&scoped=true"
import script from "./tiktok_applicant.vue?vue&type=script&lang=ts"
export * from "./tiktok_applicant.vue?vue&type=script&lang=ts"
import style0 from "./tiktok_applicant.vue?vue&type=style&index=0&id=74a6b890&prod&lang=scss"
import style1 from "./tiktok_applicant.vue?vue&type=style&index=1&id=74a6b890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a6b890",
  null
  
)

export default component.exports